import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_VERSION_REQUEST = "API_VERSION_REQUEST";
export const API_VERSION_SUCCESS = "API_VERSION_SUCCESS";
export const API_VERSION_FAILURE = "API_VERSION_FAILURE";

export const api_version_request = (options) => {
	return {
		type: API_VERSION_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_version_success = (data) => {
	return {
		type: API_VERSION_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_version_failure = (error) => {
	return {
		type: API_VERSION_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Base.apiVersion
*/
export const apiVersion = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_version_request(options));
			const url=getAPIUrl([
				{"url": "/api/version", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_version_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_version_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
